<template>
  <div>
    <v-btn flat :color="ui.btnColor" @click="openImport()"
    :disabled="this.data.tag === 'E6' || this.data.tag === 'W6'">
      <v-icon left :color="ui.btnColor">
        {{item.btnIcon}}
      </v-icon>
      {{item.btnTitle}}
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :class="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-icon left color="wplblue0"> search </v-icon>
          <span :class="ui.textTitle">
            {{item.title}}
          </span>
        </v-card-title>
          <v-form ref="form" v-model="valid" v-on:submit.prevent="validate"
            lazy-validation>
            <v-container>
              <v-layout row>
                <v-flex xs10>
                  <v-text-field v-model="search.title"
                    :label="item.searchLabel1" :prepend-icon="item.searchIcon1">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <div v-if="this.getSearchResults !== null" class="mt-4">
                <v-layout row class="mr-3 ml-3">
                  <v-flex xs12 lg10 offset-lg1 xl6 offset-xl3>
                    <v-data-table
                    :headers="headers"
                    :items="getSearchResults"
                    class="elevation-1"
                    :total-items=this.maxRows
                    :hide-actions=this.hideActions
                    >
                     <template slot="items" slot-scope="props">
                       <td class="text-xs-left">
                         {{ defineTableContent(props.item).item0}}
                       </td>
                       <td class="text-xs-left">
                         {{ defineTableContent(props.item).item1 }}
                       </td>
                       <td class="text-xs-right">
                          <v-btn :color="ui.btnColor" dark icon small
                          :disabled="disableAppendAdd(props.item.basic.did)"
                          @click="changeAssetTree(props.item, 'add')"
                          >
                            <v-icon> add </v-icon>
                          </v-btn>
                       </td>
                     </template>
                   </v-data-table>
                   <v-layout row>
                     <v-progress-linear class="ml-2 mr-2"
                     :color="ui.btnColorGrey"
                     height="5"
                     :indeterminate="this.progressBarImportRelps"/>
                   </v-layout>
                 </v-flex>
                </v-layout>
              </div>
           </v-container>
           <v-layout  row>
             <v-btn
              @click="closeModal()"
              :color="ui.btnColor"
              flat
              class="hidden-xs-only"
              >
               <v-icon left> exit_to_app </v-icon>
               Close
             </v-btn>
             <v-btn
              @click="closeModal()"
              :color="ui.btnColor"
              flat
              class="hidden-sm-and-up"
              >
               <v-icon> exit_to_app </v-icon>
             </v-btn>
             <v-spacer/>
             <v-btn
               flat
               dark
               :color="ui.btnColor"
               class="hidden-xs-only"
               @click="changeAssetTree(null, 'remove')">
               <v-icon left>remove</v-icon>
               remove
             </v-btn>
             <v-btn
               flat
               dark
               :color="ui.btnColor"
               class="hidden-sm-and-up"
               @click="changeAssetTree(null, 'remove')">
               <v-icon>remove</v-icon>
             </v-btn>
             <div v-if="this.enableSpinBtnSearch === false">
               <v-btn
                 flat
                 dark
                 :color="ui.btnColor"
                 :disabled="!this.enableSearch"
                 class="hidden-xs-only"
                 @click="searchBeforeImport(search)">
                 <v-icon left>search</v-icon>
                 search
               </v-btn>
               <v-btn
                 flat
                 dark
                 :color="ui.btnColor"
                 :disabled="!this.enableSearch"
                 class="hidden-sm-and-up"
                 @click="searchBeforeImport(search)">
                 <v-icon>search</v-icon>
               </v-btn>
             </div>
             <div v-else>
               <BtnSpin :btnSpec="btnInfo1"/>
             </div>
          </v-layout>
         </v-form>
    </v-card>

    </v-dialog>
  </div>
</template>

<script>
import "firebase/firestore";
import { mapGetters } from "vuex";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import announcements from "@/frame/messages/mixins/announcements.js";
import importOptions from "@/data/options/mixins/importOptions.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import search from "@/data/search/mixins/search.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import relps from "@/data/forms/mixins/relps.js";
import limitEmbeddedList from "@/data/globals/mixins/limitEmbeddedList.js";
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";

export default {
  // eslint-disable-next-line
  components: {
    BtnSpin
  },
  props: {
    data: {
      type: Object
    }
  },
  // eslint-disable-next-line
  mixins: [
    // role,
    search,
    announcements,
    apptheme,
    dataSources,
    changeDetail,
    docRevsModFunctions,
    listFunctions,
    importOptions,
    numberFunctions,
    relps,
    revFunctions,
    getData,
    limitEmbeddedList
    // rolesFormValidation
  ],
  data() {
    return {
      dialog: false,
      valid: false,
      progressBarImportRelps: false,
      enableSpinBtnSearch: false,
      enableSpinBtnAppendGetRelps: false,
      appendLimit: 10,
      maxRows: -1,
      hideActions: true,
      barMovement: false,
      search: {
        router: false,
        type: "Operations Notifications", // type of search
        id: "", // id for search
        title: "", // title for search
        dbs: "" // data base source
      },
      enableSpinner: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        type: "icon"
      }
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getRelpsRemoteAppended",
      "getDetailBasic",
      "getDetailLink",
      "getSearchResults"
    ]),
    enableSearch() {
      let logic = false;
      if (this.search.title !== "") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    item() {
      let obj = {
        btnTitle: "append",
        btnIcon: "download_for_offline",
        title: "",
        searchLabel1: "",
        searchIcon1: "",
        importIcon: ""
      };
      if (this.data.tag === "A1") {
        obj.searchLabel1 = "asset name";
        obj.searchIcon1 = "emoji_transportation";
        obj.importIcon = "cloud";
        obj.btnTitle = "asset";
        obj.btnIcon = "emoji_transportation";
        if (this.getCurrentPage !== "/assetdetail") {
          obj.title = "Asset Search and Append";
        } else {
          obj.title = "Master Asset Append";
        }
      } else {
        obj.title = "Undefined";
      }
      return obj;
    },
    headers() {
      let head = [
        { text: "Undefind", sortable: false },
        { text: "Undefined", sortable: false },
        { text: "", sortable: false }
      ];
      if (this.data.tag === "A1") {
        head[0].text = "Tag";
        head[1].text = "Asset";
      }
      return head;
    }
  },
  methods: {
    disableAppendAdd(did) {
      let logic = null;
      if (this.getDetail === null) {
        logic = false;
      } else if (this.getDetail.basic.did === did) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    defineTableContent(item) {
      let obj = {
        item0: "", // this is id
        item1: "",
        item2: ""
      };
      if (this.data.tag === "A1") {
        obj.item0 = item.basic.id;
        obj.item1 = item.basic.title;
      } else {
        obj.item0 = "Undefined";
        obj.item1 = "Undefined";
      }
      return obj;
    },
    openImport() {
      this.dialog = true;
      this.enableSpinBtnSearch = false;
      this.progressBarImportRelps = false;
      this.$refs.form.reset();
      this.$store.dispatch("changeSearchResults", null);
      // reset search
      this.search.title = "";
      this.search.type = "";
    },
    closeModal() {
      this.dialog = false;
    },
    searchBeforeImport() {
      this.enableSpinBtnSearch = true;
      let tag = this.data.tag;
      if (tag === "A1.M") {
        tag = "A1"; // special case
      }
      this.search.dbs = this.defineDataSourceFromTag(tag);
      this.searchDocuments(this.search);
    },
    changeAssetTree(item, logic) {
      console.log(item);
      let link = this.getDetailLink;
      if (this.data.tag === "A1" || this.data.tag === "A1.M") {
        // DEFINE DATABASE SOURCE
        let dbTree = this.dbAssetTreeUndefined;
        // ASSET FORM DEFINE
        let tempAsset = this.formRelationshipAssetTree;
        tempAsset.did = this.getDetailBasic.did;
        tempAsset.title = this.getDetailBasic.title;
        tempAsset.tag = this.getDetailBasic.tag;
        tempAsset.idg = this.getDetailBasic.idg;
        tempAsset.id = this.getDetailBasic.id;
        // CHANEG INFO
        // CHANGE DETAIL
        this.saveDocumentRevMod(3.13, 1); // Role updated
        this.$store.dispatch("changeDataSavePendingIndication", true);
        this.$store.dispatch("changeDetailLink", link);
        // APPEND ASSET
        if (logic === "add") {
          // PART 1 APPEND PARENT ASSET to THIS ASSET
          link.aid = item.basic.id;
          link.aidg = item.basic.idg;
          link.adid = item.basic.did;
          link.at = item.basic.title;
          link.atag = "A1";

          // PART 2 APPEBD CHILD ASSET to PARENT
          // GET ASSET PARENT TREE
          let didParent = item.basic.did;
          // eslint-disable-next-line
          dbTree.doc(didParent).get().then((doc) => {
              if (doc.exists) {
                let parentTree = doc.data();
                let oldTree = parentTree.a1;
                // ASSIGN IDI to ASSET
                tempAsset.idi = this.findIdiMax(oldTree) + 1;
                let obj = Object.assign({}, tempAsset);
                let parseobj = JSON.parse(JSON.stringify(obj));
                let newTree = this.appendItemLimitedwithDuplicateCheck(
                  parseobj,
                  oldTree,
                  this.assetRegisterImportLimit,
                  "Asset"
                );
                // APPEND PARENT
                parentTree.a1 = newTree;
                // eslint-disable-next-line
                dbTree.doc(didParent).set(parentTree).then(() => {
                    // UPDATE MAIN
                    this.changeDetail();
                    // MESSAGE
                    let msg = "Asset ";
                    msg = msg + this.getDetailBasic.title + " (";
                    msg = msg + this.getDetailBasic.id + ") ";
                    msg = msg + "was updated with new asset ";
                    msg = msg + link.at + " (";
                    msg = msg + link.aid + ").";
                    this.generateInfoSnackbar(this.ui.colorBlue1, msg);
                  });
              }
            });
          // RESET ASSET
        } else {
          // PART 2 REMOVE CHILD FROM PARENT
          // GET ASSET PARENT TREE
          let didParent = link.adid;
          // eslint-disable-next-line
          dbTree.doc(didParent).get().then((doc) => {
              if (doc.exists) {
                let parentTree = doc.data();
                let oldTree = parentTree.a1;
                let obj = Object.assign({}, tempAsset);
                let parseobj = JSON.parse(JSON.stringify(obj));
                // let newTree = [];
                let newTree = this.deleteAssetReturnTree(parseobj, oldTree);
                // APPEND PARENT
                console.log("New Tree");
                parentTree.a1 = newTree;
                console.log(newTree);
                // eslint-disable-next-line
                dbTree.doc(didParent).set(parentTree).then(() => {
                    // MESSAGE
                    let msg = "Asset ";
                    msg = msg + this.getDetailBasic.title + " (";
                    msg = msg + this.getDetailBasic.id + ") ";
                    msg = msg + "was removed from asset tree ";
                    msg = msg + link.at + " (";
                    msg = msg + link.aid + ").";
                    this.generateInfoSnackbar(this.ui.colorBlue1, msg);
                    // PART 1 RESET PARENT
                    link.aid = "";
                    link.aidg = "";
                    link.adid = "";
                    link.at = "";
                    link.atag = "";
                    // UPDATE MAIN
                    this.changeDetail();
                  });
              }
            });
        }
      }
    }
  }
};
</script>
